var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSg = function SvgSg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21769_20218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21769_20218)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 10,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#D33D3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14453 8.71887C6.50762 8.48545 5.2491 7.07791 5.2491 5.37643C5.2491 3.72023 6.44151 2.34255 8.01463 2.0551C7.81581 2.01891 7.61096 2 7.40169 2C5.52393 2 4.00169 3.52229 4.00169 5.40013C4.00169 7.27797 5.52393 8.80026 7.40169 8.80026C7.65685 8.80026 7.90543 8.77215 8.14453 8.71887Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0208 2.54883L10.2079 3.12467H10.8134L10.3236 3.48056L10.5107 4.0564L10.0208 3.70051L9.53101 4.0564L9.71811 3.48056L9.22829 3.12467H9.83374L10.0208 2.54883Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9857 3.98242L12.1728 4.55826H12.7782L12.2884 4.91415L12.4755 5.48999L11.9857 5.1341L11.4959 5.48999L11.683 4.91415L11.1931 4.55826H11.7986L11.9857 3.98242Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98568 3.98242L8.17277 4.55826H8.77822L8.2884 4.91415L8.4755 5.48999L7.98568 5.1341L7.49586 5.48999L7.68295 4.91415L7.19313 4.55826H7.79858L7.98568 3.98242Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98568 6.18359L9.17277 6.75943H9.77822L9.2884 7.11532L9.4755 7.69117L8.98568 7.33528L8.49586 7.69117L8.68295 7.11532L8.19313 6.75943H8.79858L8.98568 6.18359Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1849 6.18359L11.372 6.75943H11.9774L11.4876 7.11532L11.6747 7.69117L11.1849 7.33528L10.6951 7.69117L10.8822 7.11532L10.3923 6.75943H10.9978L11.1849 6.18359Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sg.67f36c6e328d130455ef2c03f27c02be.svg";